import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import Layout from '../layout';

import styles from '../styles/pages/product-list.scss';
import loadingStyles from '../styles/components/loading.scss';

import ProductList from '../product-list';
import APP_ROUTES from '../../constants/app-routes';
import SignupPromotion from '../shared/signup-promotion';
import SecondaryMenuConnector from '../../containers/menus/secondary-menu-connector';

class ProductListPage extends Component {
    constructor(props) {
        super(props);
        document.title = this.props.intl.formatMessage({ id: 'product-list', defaultMessage: 'List of products' });
    }

    componentDidMount() {
        const query = new URLSearchParams(this.props.location.search);
        const params = {};
        // eslint-disable-next-line no-restricted-syntax
        for (const [param0, param1] of query.entries()) {
            params[param0] = param1;
        }

        this.props.loadStores(this.props.locale.currentLocale, this.props.currentStore);
    }

    /* If home page icon is clicked. */
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.location.pathname !== this.props.location.pathname
            || prevProps.locale.currentLocale !== this.props.locale.currentLocale
            || prevProps.location.search !== this.props.location.search
        ) {
            const query = new URLSearchParams(this.props.location.search);
            const params = {};

            // eslint-disable-next-line no-restricted-syntax
            for (const [param0, param1] of query.entries()) {
                params[param0] = param1;
            }
            this.props.triggerInitialSetup(this.props.locale.currentLocale);
        }
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'product-list', defaultMessage: 'List of products' });
        }
    }

    render() {
        return (
            <Layout notShowMarginBottom>
                <div className={styles.productList}>
                    <div className={`container body-container ${styles.bodyContainer}`}>
                        <div className="row">
                            <div className={`col-lg-3 col-md-3 col-sm-4 col-xs-12 ${styles.colFilters}`}>
                                <SecondaryMenuConnector location={this.props.location} path={APP_ROUTES.searchPageRoute} />
                            </div>
                            <div className="col-lg-9 col-md-9 col-sm-8 col-xs-12">
                                <div className={`${styles.contentCategory}`}>
                                    <div className="row">
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            {!this.props.displayLoader && (
                                                <label className={`${styles.titleSection}`}>
                                                    <FormattedMessage id="our" defaultMessage="Our" />
                                                    <FormattedMessage id="recommendations" defaultMessage="recommendations" />
                                                </label>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row no-margin">
                                        {this.props.displayLoader && (
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                                                <div>
                                                    <h4 className={styles.loadingText}>
                                                        <FormattedMessage id="loading-recommendations" defaultMessage="Loading recommendations" />
                                                        <span className="hidden-xs">
                                                            {', '}
                                                            <FormattedMessage id="please-wait" defaultMessage="please wait" />
                                                        </span>
                                                        ...
                                                    </h4>
                                                    <div className={loadingStyles.spinnerDark} />
                                                </div>
                                            </div>
                                        )}
                                        {!this.props.displayLoader && (
                                            <ProductList
                                                products={this.props.products}
                                                loadMoreProducts={this.props.loadMoreProducts}
                                                pageCount={this.props.pageCount}
                                                searchTerm={this.props.location.pathname}
                                                locale={this.props.locale}
                                            />
                                        )}
                                    </div>
                                </div>
                                {/* <div className={`${styles.contentCategory}`}>
                                    <div className="row">
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            {!this.props.displayLoader && (
                                                <label className={`${styles.titleSection}`}>
                                                    <FormattedMessage id="our" defaultMessage="Our" />
                                                    <FormattedMessage id="recommendations" defaultMessage="recommendations" />
                                                </label>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row no-margin">
                                        {this.props.displayLoader && (
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                                                <div>
                                                    <h4 className={styles.loadingText}>
                                                        <FormattedMessage id="loading-recommendations" defaultMessage="Loading recommendations" />
                                                        <span className="hidden-xs">
                                                            {', '}
                                                            <FormattedMessage id="please-wait" defaultMessage="please wait" />
                                                        </span>
                                                        ...
                                                    </h4>
                                                    <div className={loadingStyles.spinnerDark} />
                                                </div>
                                            </div>
                                        )}
                                        {!this.props.displayLoader && (
                                            <ProductList
                                                products={this.props.allStoreProducts}
                                                loadMoreProducts={this.props.loadMoreProducts}
                                                pageCount={this.props.pageCount}
                                                searchTerm={this.props.location.pathname}
                                                locale={this.props.locale}
                                            />
                                        )}
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }
}

export default injectIntl(ProductListPage);



/** WEBPACK FOOTER **
 ** ./src/components/pages/product-list.jsx
 **/